import React from 'react';
import AlertSnoozeModal from 'alerts/AlertSnoozeModal'
import { Button } from 'react-bootstrap';

class Alert extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDetails: false,
      resolved: this.props.alert.resolved
    }
  }

  toggleDetails() {
    this.setState({ showDetails: !this.state.showDetails });
  }

  toggleResolved() {
    this.props.resolveAlert(this.props.alert.id, !this.state.resolved);
    this.setState({ resolved: !this.state.resolved });
  }

  render() {
    let section = capitalize(this.props.alert.alert_type.toLowerCase())
    if (section == "Seo") {
      section = "SEO";
    }

    return (
      <React.Fragment>
        <tr className={`alert-text${this.state.resolved ? " resolved" : ""}`} key={this.props.alert.id}>
          <td width="55%">
            <div>
              <span style={this.props.alert.emergency ? {color: "red", fontWeight: "bold"} : undefined}>
                {this.props.alert.emergency &&
                  <i className="fas fa-exclamation pr-2"></i>
                }
                {this.props.alert.text}
              </span>
              {this.props.alert.secondary_text &&
                <>
                  <span className="view-details" onClick={() => this.toggleDetails()}>
                    <span style={{pointerEvents: "none"}}>
                      <i className={"fas " + (this.state.showDetails ? "fa-sort-up" : "fa-sort-down")}></i>
                      <a>{this.state.showDetails ? "Collapse Details" : "View Details"}</a>
                    </span>
                  </span>

                </>
              }
            </div>
          </td>
          <td width="10%">
            <div className="alert-type">
              <b>{section}</b>
            </div>
          </td>
          <td width="25%" style={{textAlign: "right"}}>
            <div className="alert-actions">
              <AlertSnoozeModal alert={this.props.alert} snoozeAlert={this.props.snoozeAlert} showBtnText={false} />
              <Button variant="success" className="mx-1 d-inline-block" onClick={() => this.toggleResolved()}>
                {/* <i className="fas fa-check"></i>
                { this.state.resolved ? "Unresolve" : "Resolve" } */}
                {this.state.resolved ?
                    <i className="fas fa-times"></i>
                  :
                    <i className="fas fa-check"></i>
                }
              </Button>
            </div>
          </td>
        </tr>
        {this.state.showDetails &&
          <tr className={`alert-details${this.state.resolved ? " resolved" : ""}`}>
            <td>
              <div className="alert-details-inner" dangerouslySetInnerHTML={{ __html: this.props.alert.secondary_text }}>
              </div>
            </td>
            <td colSpan="2"></td>
          </tr>
        }
        <tr className="spacer-row"></tr>
      </React.Fragment>
    )
  }
}

export default Alert;
